import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_NAME = "Oblastný futbalový zväz Levice";
const DEFAULT_DESC =
  "Oficiálny web ObFZ Levice — úradné správy, súťaže, rozpisy, rozhodcovia a delegáti, dokumenty a kontakty oblastného futbalu v levickom regióne.";

// Reusable SEO / meta-tag component for each page.
export default function Seo({ title, description, noindex = false, image }) {
  const { pathname } = useLocation();
  const origin =
    typeof window !== "undefined" && window.location
      ? window.location.origin
      : "https://obfz-levice.emergent.host";
  const url = `${origin}${pathname}`;
  const fullTitle = title ? `${title} | ObFZ Levice` : `${SITE_NAME} | Oficiálny web`;
  const desc = description || DEFAULT_DESC;
  const ogImage = image || `${origin}/logo512.png`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="sk_SK" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
